import { Add, ArrowLeft, ArrowRightAlt, Assignment, CancelOutlined, CloudUpload, Delete, DragIndicator } from '@mui/icons-material';
import { Alert, Box, Button, Grid, IconButton, InputAdornment, MenuItem, Paper, Step, StepLabel, Stepper, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Field, FieldArray, Form, Formik, useFormik, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import { ErrorMessage } from "formik";
import { ApiCreateProduct, ApiGetAllCategory, ApiGetAllColors, ApiGetAllGender, ApiGetAllSizes, ApiUploadImage } from '../../Core/Apicall';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import categories from '../../Categories/categories.json'
import {
    DndContext,
    closestCenter,
} from "@dnd-kit/core";

import {
    SortableContext,
    arrayMove,
    rectSortingStrategy,
    useSortable,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";





const SortableImage = ({
    item,
    index,
    large = false,
    onDelete,
}: any) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: item.id || item.media_url || item.image_url,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            // {...attributes}
            // {...listeners}
            sx={{
                position: "relative",
                display: "inline-block",
                width: "100%",
                cursor: "grab",
                "&:hover .delete-btn": {
                    opacity: 1,
                },
            }}
        >
            <IconButton
                {...attributes}
                {...listeners}
                sx={{
                    position: "absolute",
                    bottom: 8,
                    left: 8,
                    zIndex: 10,
                }}
            >
                <DragIndicator />
            </IconButton>

            <Box
                component="img"
                src={item.media_url || item.image_url}

                alt="Preview"
                sx={{
                    width: "100%",
                    height: large ? "auto" : 120,
                    maxHeight: large ? "400px" : undefined,
                    objectFit: large ? "contain" : "cover",
                    borderRadius: 2,
                    border: "1px solid #444",
                }}
            />

            {index === 0 && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        px: 1,
                        py: 0.5,
                        bgcolor: "var(--third-color)",
                        color: "#fff",
                        borderRadius: 1,
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    Thumbnail
                </Box>
            )}

            <IconButton
                className="delete-btn"
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete(index);
                }}
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    bgcolor: "rgba(0,0,0,0.7)",
                    color: "#fff",
                    opacity: 0,
                    transition: "opacity 0.2s ease",
                    "&:hover": {
                        bgcolor: "error.main",
                    },
                }}
            >
                <Delete />
            </IconButton>
        </Box>
    );
};

export const ProductInfo = ({ categoryList, genderList }: any) => {
    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <Field name="productName">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            label="Product Name"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>

            <Grid size={12}>
                <Field name="description">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            rows={4}
                            multiline
                            label="Description"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>

            {/* <Grid size={6}>
                <Field name="seller_id">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            label="Seller ID"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid> */}

            {/* <Grid size={6}>
                <Field name="currency">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            label="Currency"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid> */}

            <Grid size={6}>
                <Field name="categoryId">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            select
                            fullWidth
                            label="Category"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        >
                            <MenuItem value="">Select Category</MenuItem>

                            {categoryList?.map((category: Category) => (
                                <MenuItem key={category.categoryId} value={category.categoryId}>
                                    {category.categoryName}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </Field>
            </Grid>
            <Grid size={6}>
                <Field name="genderId">
                    {({ field, meta }: any) => (
                        <TextField
                            {...field}
                            select
                            fullWidth
                            label="Gender"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        >
                            <MenuItem value="">Select Category</MenuItem>

                            {genderList?.map((gender: Gender) => (
                                <MenuItem key={gender.genderId} value={gender.genderId}>
                                    {gender.genderName}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </Field>
            </Grid>

            <Grid size={6}>
                <Field name="base_price">
                    {({ field, meta, form }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            type='number'
                            label="Base Price (AUD)"
                            onChange={(e: any) => {
                                const basePrice = Number(e.target.value);
                                const discount = Number(form.values.discount_percentage);

                                const discountedPrice =
                                    basePrice - (basePrice * discount) / 100;
                                form.setFieldValue("base_price", e.target.value);
                                if (basePrice && discount > -1) {
                                    form.setFieldValue(
                                        "discounted_price",
                                        discountedPrice.toFixed(2)
                                    );
                                }
                            }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <span className='text-white'>$</span>
                                        </InputAdornment>
                                    ),
                                },
                            }}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>
            <Grid size={6}>
                <Field name="discount_percentage">
                    {({ field, meta, form }: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            type='number'
                            label="Discount (if any)"
                            inputProps={{
                                min: 0,
                            }}
                            onChange={(e: any) => {
                                if (e.target.value < 0) return;
                                const discount = Number(e.target.value);
                                const basePrice = Number(form.values.base_price);

                                const discountedPrice =
                                    basePrice - (basePrice * discount) / 100;

                                form.setFieldValue(
                                    "discount_percentage",
                                    e.target.value
                                );
                                if (discount > -1 && basePrice) {
                                    form.setFieldValue(
                                        "discounted_price",
                                        discountedPrice.toFixed(2)
                                    );
                                }
                            }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <span className='text-white'>%</span>
                                        </InputAdornment>
                                    ),
                                },
                            }}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>
            <Grid size={6}>
                <Field name="discounted_price">
                    {({ field, meta }: any) => (
                        <TextField
                            disabled
                            {...field}
                            fullWidth
                            type='number'
                            label="Selling Price"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                        />
                    )}
                </Field>
            </Grid>
        </Grid>
    )
}

export const ProductMedia = ({
    values,
    setFieldValue,
}: ProductMediaProps) => {
    const handleDragEnd = (event: any) => {
        const { active, over } = event;

        if (!over || active.id === over.id) return;

        const oldIndex = values.product_media.findIndex(
            (item: any) => item.media_url === active.id
        );

        const newIndex = values.product_media.findIndex(
            (item: any) => item.media_url === over.id
        );

        const reordered = arrayMove(
            values.product_media,
            oldIndex,
            newIndex
        );

        const updated = reordered.map((item: any, index: number) => ({
            ...item,
            sort_order: index + 1,
            is_thumbnail: index === 0,
        }));

        setFieldValue("product_media", updated);
    };

    // const [count, setCount] = useState(0)
    const uploadImage = async (file: File, push: any, index: number) => {
        try {
            const payload = new FormData();

            payload.append("images[]", file);
            payload.append("type", "category");

            const res = await ApiUploadImage(payload);

            if (res.status || res.success) {
                push({
                    media_url: res.data[0].media_url,
                    media_type: "IMAGE",
                    sort_order: index + 1,
                    is_thumbnail: index === 0,
                    alt_text: `Product_Image_${index + 1}`,
                });
            }
            else {
                toast.error(res.message.replace(/<[^>]*>/g, ""))
            }
        } catch (error: any) {
            // toast.error(error?.message || "Something went wrong");
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";
            toast.error(
                errorMessage.replace(/<[^>]*>/g, "") // removes HTML tags
            );
        }
    };

    return (
        <FieldArray name="product_media">
            {({ push, remove }) => (
                <>
                    <Paper
                        className="bg-transparent"
                        sx={{
                            p: 2,
                            mb: 3,
                            boxShadow: "none",
                        }}
                    >
                        <Typography className='fs-12 text-grey' gutterBottom> Note: Please upload one of your variant images as the main product image.</Typography>
                        <Grid container spacing={2}>
                            {/* Upload Box */}
                            <Grid size={12}>
                                <Box
                                    className='w-100'
                                    sx={{
                                        border: "2px dashed #666",
                                        borderRadius: "12px",
                                        p: 4,
                                        textAlign: "center",
                                        cursor: "pointer",
                                        transition: "0.3s",
                                        "&:hover": {
                                            borderColor: "#f5c542",
                                            background:
                                                "rgba(245,197,66,0.05)",
                                        },
                                    }}
                                    component="label"
                                >
                                    <input
                                        hidden
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        onChange={(e) => {
                                            const files = Array.from(e.target.files || []);

                                            files.forEach((file, index) => {
                                                uploadImage(
                                                    file,
                                                    push,
                                                    values.product_media.length + index
                                                );
                                            });

                                            // Optional: reset input so same files can be selected again
                                            e.target.value = "";
                                        }}
                                    />

                                    <CloudUpload className='text-white fs-48' />

                                    <Typography className='fs-16 text-white' gutterBottom
                                    >
                                        Click to upload image
                                    </Typography>

                                    <Typography className='text-grey fs-12'>
                                        PNG, JPG, WEBP
                                    </Typography>
                                </Box>
                            </Grid>

                            <ErrorMessage
                                name="product_media"
                                component="div"
                                className="text-danger"

                            />

                            {/* Preview */}
                            {/* <Grid size={12}>
                                <Grid container spacing={1.5} className='h-content'>
                                    {values.product_media[0]?.media_url && (
                                        <Grid size={6} className='h-content'>
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    width: "100%",
                                                    "&:hover .delete-btn": {
                                                        opacity: 1,
                                                    },
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={values?.product_media[0]?.media_url}
                                                    alt="Preview"
                                                    sx={{
                                                        width: "100%",
                                                        height: "auto",
                                                        maxHeight: '400px',
                                                        objectFit: "contain",
                                                        borderRadius: 2,
                                                        border: "1px solid #444",
                                                    }}
                                                />

                                                <IconButton
                                                    className="delete-btn"
                                                    onClick={() => {
                                                        const updatedMedia = [...values.product_media];
                                                        updatedMedia.splice(0, 1); // remove first image

                                                        setFieldValue("product_media", updatedMedia);
                                                    }}
                                                    sx={{
                                                        position: "absolute",
                                                        top: 8,
                                                        right: 8,
                                                        bgcolor: "rgba(0,0,0,0.7)",
                                                        color: "#fff",
                                                        opacity: 0,
                                                        transition: "opacity 0.2s ease",
                                                        "&:hover": {
                                                            bgcolor: "error.main",
                                                        },
                                                    }}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </Box>

                                        </Grid>
                                    )}
                                    <Grid size={6} className='h-content'>
                                        <Grid container spacing={1}>
                                            {values.product_media?.map(
                                                (item: any, index: number) => index > 0 && (
                                                    item?.media_url && (
                                                        <Grid size={6}>
                                                            <Box
                                                                sx={{
                                                                    position: "relative",
                                                                    display: "inline-block",
                                                                    width: "100%",
                                                                    "&:hover .delete-btn": {
                                                                        opacity: 1,
                                                                    },
                                                                }}
                                                            >
                                                                <Box
                                                                    component="img"
                                                                    src={item.media_url}
                                                                    alt="Preview"
                                                                    sx={{
                                                                        width: "100%",
                                                                        height: 120,
                                                                        objectFit: "cover",
                                                                        borderRadius: 2,
                                                                        border: "1px solid #444",
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    className="delete-btn"
                                                                    onClick={() => {
                                                                        const updatedMedia = [...values.product_media];
                                                                        updatedMedia.splice(0, 1); // remove first image

                                                                        setFieldValue("product_media", updatedMedia);
                                                                    }}
                                                                    sx={{
                                                                        position: "absolute",
                                                                        top: 8,
                                                                        right: 8,
                                                                        bgcolor: "rgba(0,0,0,0.7)",
                                                                        color: "#fff",
                                                                        opacity: 0,
                                                                        transition: "opacity 0.2s ease",
                                                                        "&:hover": {
                                                                            bgcolor: "error.main",
                                                                        },
                                                                    }}
                                                                >
                                                                    <Delete />
                                                                </IconButton>
                                                            </Box>
                                                        </Grid>
                                                    )
                                                )
                                            )}
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid> */}
                            <Grid size={12}>
                                <DndContext
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleDragEnd}
                                >
                                    <SortableContext
                                        items={values.product_media.map(
                                            (item: any) => item.media_url
                                        )}
                                        strategy={rectSortingStrategy}
                                    >
                                        <Grid container spacing={1.5} className="h-content">
                                            {values.product_media[0] && (
                                                <Grid size={6}>
                                                    <SortableImage
                                                        item={values.product_media[0]}
                                                        index={0}
                                                        large
                                                        onDelete={(deleteIndex: number) => {
                                                            const updated = [...values.product_media];
                                                            updated.splice(deleteIndex, 1);
                                                            setFieldValue(
                                                                "product_media",
                                                                updated.map((item, i) => ({
                                                                    ...item,
                                                                    sort_order: i + 1,
                                                                    is_thumbnail: i === 0,
                                                                }))
                                                            );
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid size={6}>
                                                <Grid container spacing={1}>
                                                    {values.product_media.map(
                                                        (item: any, index: number) =>
                                                            index > 0 && (
                                                                <Grid
                                                                    size={6}
                                                                    key={item.media_url}
                                                                >
                                                                    <SortableImage
                                                                        item={item}
                                                                        index={index}
                                                                        onDelete={(deleteIndex: number) => {
                                                                            const updated = [
                                                                                ...values.product_media,
                                                                            ];

                                                                            updated.splice(deleteIndex, 1);
                                                                            setFieldValue(
                                                                                "product_media",
                                                                                updated.map((item, i) => ({
                                                                                    ...item,
                                                                                    sort_order: i + 1,
                                                                                    is_thumbnail: i === 0,
                                                                                }))
                                                                            );
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            )
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </SortableContext>
                                </DndContext>
                            </Grid>

                        </Grid>
                    </Paper>
                </>
            )}
        </FieldArray>
    );
};

export const ProductVariants = ({ values, setFieldValue, colorList, sizeList }: any) => {
    const uploadImage = async (file: File, push: any, index: number) => {
        try {
            const payload = new FormData();

            payload.append("images[]", file);
            payload.append("type", "category");

            const res = await ApiUploadImage(payload);

            if (res.status || res.success) {
                push({
                    image_url: res.data[0].media_url,
                    is_active: true,
                    sort_order: index + 1,
                    is_thumbnail: index === 0,
                    alt_text: `Varinet_Image_${index + 1}`,
                });
            }
            else {
                toast.error(res.message.replace(/<[^>]*>/g, ""))
            }
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";
            console.log("Error Message", errorMessage)
            toast.error(
                errorMessage.replace(/<[^>]*>/g, "") // removes HTML tags
            );
        }
    };

    const handleVariantImageDrag = (
        variantIndex: number,
        event: any,
        values: any,
        setFieldValue: any
    ) => {
        const { active, over } = event;

        if (!over || active.id === over.id) return;

        const images = values.variants[variantIndex].images || [];

        const oldIndex = images.findIndex(
            (i: any) =>
                (i.id || i.image_url) === active.id
        );

        const newIndex = images.findIndex(
            (i: any) =>
                (i.id || i.image_url) === over.id
        );

        const reordered = arrayMove(images, oldIndex, newIndex).map(
            (img: any, idx: number) => ({
                ...img,
                sort_order: idx + 1,
                is_thumbnail: idx === 0,
            })
        );

        setFieldValue(
            `variants.${variantIndex}.images`,
            reordered
        );
    };
    // console.log("Erryysysys", errors);
    return (
        <FieldArray name="variants" >
            {({ push, remove }) => (
                <>
                    {values.variants.map(
                        (
                            variant: any,
                            index: number
                        ) =>
                        (
                            <Paper
                                className='bg-transparent border-grey' sx={{ p: 2, mb: 2, boxShadow: 'none', borderRadius: "0px" }}
                                key={index}
                            >
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid size={12} className='custom-toggle'>
                                        <Box className='d-flex align-items-center mb-3 justify-content-between'>
                                            <Typography className="text-white fs-14 fw-bold mb-2">
                                                Color
                                            </Typography>
                                            <Button className='btn-light-yellow px-3'><Add className='fs-18' /> Add</Button>
                                        </Box>

                                        <ToggleButtonGroup
                                            className='d-flex w-100'
                                            fullWidth
                                            exclusive
                                            value={values.variants[index].colorId}
                                            // defaultValue={values.variants[0].colorId}
                                            onChange={(_, newValue) => {
                                                if (newValue !== null) {
                                                    setFieldValue(`variants.${index}.colorId`, newValue);
                                                }
                                            }}
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                flexWrap: "wrap",

                                                "& .MuiToggleButton-root": {
                                                    gap: 1,
                                                },

                                            }}
                                        >
                                            <Grid container className='w-100 flex-wrap' spacing={1.5}>
                                                {colorList?.map((item: Color, index: number) => (
                                                    <Grid size={'auto'}>
                                                        <ToggleButton key={item?.colorId} value={item.colorId}>
                                                            <Box
                                                                sx={{
                                                                    width: 14,
                                                                    height: 14,
                                                                    borderRadius: "50%",
                                                                    background: item.colorCode,
                                                                    border: "2px solid #666",
                                                                }}
                                                            />
                                                            <span>{item?.colorName}</span>
                                                        </ToggleButton>
                                                    </Grid>

                                                ))}
                                            </Grid>
                                        </ToggleButtonGroup>
                                    </Grid>

                                    <Grid size={12} className='custom-toggle mt-3'>
                                        <Box className='d-flex align-items-center mb-3 justify-content-between'>
                                            <Typography className="text-white fs-14 fw-bold mb-2">
                                                Size
                                            </Typography>
                                            <Button className='btn-light-yellow px-3'><Add className='fs-18' /> Add</Button>
                                        </Box>
                                        <ToggleButtonGroup
                                            fullWidth
                                            exclusive
                                            value={values.variants[index].sizeId}
                                            onChange={(_, newValue) => {
                                                if (newValue !== null) {
                                                    setFieldValue(`variants.${index}.sizeId`, newValue);
                                                }
                                            }}
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                flexWrap: "wrap",

                                                "& .MuiToggleButton-root": {
                                                    gap: 1,
                                                },

                                            }}
                                        >
                                            <Grid container className='w-100 flex-wrap' spacing={1.5}>
                                                {sizeList?.map((item: Size, index: number) => (
                                                    <Grid size={'auto'}>
                                                        <ToggleButton key={item?.sizeId} value={item?.sizeId}>
                                                            <Assignment className='fs-14 p-0 m-0' />
                                                            {item?.sizeName}
                                                        </ToggleButton>
                                                    </Grid>

                                                ))}

                                            </Grid>
                                        </ToggleButtonGroup>
                                        {/* {(touched?.variants?.[index]?.sizeId) &&
                                            (errors as any)?.[index]?.sizeId && (
                                                <Typography
                                                    className='text-danger fs-12 mt-1'
                                                >
                                                    {(errors as any)?.[index].sizeId}
                                                </Typography>
                                            )} */}
                                    </Grid>

                                    <Grid size={6} className="mt-3">
                                        <Field name={`variants.${index}.price`}>
                                            {({ field, meta, form }: any) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="number"
                                                    label="Price"
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const price = Number(e.target.value);
                                                        const discountPercentage = Number(
                                                            values.variants[index].discount_percentage || 0
                                                        );

                                                        const discountedPrice =
                                                            price - (price * discountPercentage) / 100;

                                                        form.setFieldValue(
                                                            `variants.${index}.price`,
                                                            e.target.value
                                                        );

                                                        form.setFieldValue(
                                                            `variants.${index}.discounted_price`,
                                                            discountedPrice.toFixed(2)
                                                        );
                                                    }}
                                                    error={meta.touched && Boolean(meta.error)}
                                                    helperText={meta.touched && meta.error}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </Grid>

                                    <Grid size={6} className="mt-3">
                                        <Field name={`variants.${index}.discount_percentage`}>
                                            {({ field, meta, form }: any) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="number"
                                                    label="Discount (%)"
                                                    onChange={(e: any) => {
                                                        if (e.target.value < 0) return;
                                                        const discountPercentage = Number(e.target.value);
                                                        const price = Number(
                                                            values.variants[index].price || 0
                                                        );

                                                        const discountedPrice =
                                                            price - (price * discountPercentage) / 100;

                                                        form.setFieldValue(
                                                            `variants.${index}.discount_percentage`,
                                                            e.target.value
                                                        );

                                                        form.setFieldValue(
                                                            `variants.${index}.discounted_price`,
                                                            discountedPrice.toFixed(2)
                                                        );
                                                    }}
                                                    error={meta.touched && Boolean(meta.error)}
                                                    helperText={meta.touched && meta.error}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <span className='text-white'>%</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </Grid>

                                    <Grid size={6} className="mt-3">
                                        <Field name={`variants.${index}.discounted_price`}>
                                            {({ field, meta }: any) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type="number"
                                                    label="Selling Price"
                                                    disabled
                                                    error={meta.touched && Boolean(meta.error)}
                                                    helperText={meta.touched && meta.error}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <span className='text-white'>$</span>
                                                                </InputAdornment>
                                                            ),
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </Grid>
                                    <Grid size={6} className='mt-3'>
                                        <Field name={`variants.${index}.stock`}>
                                            {({ field, meta }: any) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    type='number'
                                                    label="Stock"
                                                    error={meta.touched && Boolean(meta.error)}
                                                    helperText={meta.touched && meta.error}
                                                />
                                            )}
                                        </Field>
                                    </Grid>
                                </Grid>

                                <FieldArray name={`variants.${index}.images`}>
                                    {({ push, remove }) => (
                                        <>
                                            <Paper
                                                className="bg-transparent"
                                                sx={{
                                                    p: 2,
                                                    mb: 3,
                                                    boxShadow: "none",
                                                }}
                                            >
                                                <Grid container spacing={2}>
                                                    {/* Upload Box */}
                                                    <Grid size={12}>
                                                        <Box
                                                            className='w-100'
                                                            sx={{
                                                                border: "2px dashed #666",
                                                                borderRadius: "12px",
                                                                p: 4,
                                                                textAlign: "center",
                                                                cursor: "pointer",
                                                                transition: "0.3s",
                                                                "&:hover": {
                                                                    borderColor: "#f5c542",
                                                                    background:
                                                                        "rgba(245,197,66,0.05)",
                                                                },
                                                            }}
                                                            component="label"
                                                        >
                                                            <input
                                                                hidden
                                                                type="file"
                                                                multiple
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    const files = Array.from(e.target.files || []);

                                                                    files.forEach((file, index) => {
                                                                        uploadImage(
                                                                            file,
                                                                            push,
                                                                            variant?.images?.length + index
                                                                        );
                                                                    });

                                                                    // Optional: reset input so same files can be selected again
                                                                    e.target.value = "";
                                                                }}
                                                            />

                                                            <CloudUpload className='text-white fs-48' />

                                                            <Typography className='fs-16 text-white' gutterBottom
                                                            >
                                                                Click to upload image
                                                            </Typography>

                                                            <Typography className='text-grey fs-12'>
                                                                PNG, JPG, WEBP
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid size={12}>
                                                        <Grid container spacing={1.5} className='h-content'>
                                                            {/* {variant.images?.[0]?.image_url && (
                                                                <Grid size={6} className='h-content'>
                                                                    <Box
                                                                        sx={{
                                                                            position: "relative",
                                                                            display: "inline-block",
                                                                            width: "100%",
                                                                            "&:hover .delete-btn": {
                                                                                opacity: 1,
                                                                            },
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            component="img"
                                                                            src={variant.images?.[0]?.image_url}
                                                                            alt="Preview"
                                                                            sx={{
                                                                                width: "100%",
                                                                                height: "auto",
                                                                                maxHeight: '400px',
                                                                                objectFit: "contain",
                                                                                borderRadius: 2,
                                                                                border: "1px solid #444",
                                                                            }}
                                                                        />

                                                                        <IconButton
                                                                            className="delete-btn"
                                                                            onClick={() => {
                                                                                const updatedMedia = [...variant.images];
                                                                                updatedMedia.splice(0, 1); // remove first image

                                                                                setFieldValue(`variants.${index}.images`, updatedMedia);
                                                                            }}
                                                                            sx={{
                                                                                position: "absolute",
                                                                                top: 8,
                                                                                right: 8,
                                                                                bgcolor: "rgba(0,0,0,0.7)",
                                                                                color: "#fff",
                                                                                opacity: 0,
                                                                                transition: "opacity 0.2s ease",
                                                                                "&:hover": {
                                                                                    bgcolor: "error.main",
                                                                                },
                                                                            }}
                                                                        >
                                                                            <Delete />
                                                                        </IconButton>
                                                                    </Box>

                                                                </Grid>
                                                            )}
                                                            <Grid size={6} className='h-content'>
                                                                <Grid container spacing={1}>
                                                                    {variant.images?.map(
                                                                        (item: any, index: number) => index > 0 && (
                                                                            item?.image_url && (
                                                                                <Grid size={6}>
                                                                                    <Box
                                                                                        sx={{
                                                                                            position: "relative",
                                                                                            display: "inline-block",
                                                                                            width: "100%",
                                                                                            "&:hover .delete-btn": {
                                                                                                opacity: 1,
                                                                                            },
                                                                                        }}
                                                                                    >
                                                                                        <Box
                                                                                            component="img"
                                                                                            src={item.image_url}
                                                                                            alt="Preview"
                                                                                            sx={{
                                                                                                width: "100%",
                                                                                                height: 120,
                                                                                                objectFit: "cover",
                                                                                                borderRadius: 2,
                                                                                                border: "1px solid #444",
                                                                                            }}
                                                                                        />
                                                                                        <IconButton
                                                                                            className="delete-btn"
                                                                                            onClick={() => {
                                                                                                const updatedMedia = [...variant.images];
                                                                                                updatedMedia.splice(0, 1); // remove first image

                                                                                                setFieldValue(`variants.${index}.images`, updatedMedia);
                                                                                            }}
                                                                                            sx={{
                                                                                                position: "absolute",
                                                                                                top: 8,
                                                                                                right: 8,
                                                                                                bgcolor: "rgba(0,0,0,0.7)",
                                                                                                color: "#fff",
                                                                                                opacity: 0,
                                                                                                transition: "opacity 0.2s ease",
                                                                                                "&:hover": {
                                                                                                    bgcolor: "error.main",
                                                                                                },
                                                                                            }}
                                                                                        >
                                                                                            <Delete />
                                                                                        </IconButton>
                                                                                    </Box>
                                                                                </Grid>
                                                                            )
                                                                        )
                                                                    )}
                                                                </Grid>
                                                            </Grid> */}

                                                            {variant.images?.length > 0 && (
                                                                <DndContext
                                                                    collisionDetection={closestCenter}
                                                                    onDragEnd={(event) =>
                                                                        handleVariantImageDrag(
                                                                            index,
                                                                            event,
                                                                            values,
                                                                            setFieldValue
                                                                        )
                                                                    }
                                                                >
                                                                    <SortableContext
                                                                        items={variant.images.map(
                                                                            (i: any) => i.id || i.image_url
                                                                        )}
                                                                        strategy={rectSortingStrategy}
                                                                    >
                                                                        <Grid container spacing={1.5} className="h-content">

                                                                            {variant.images.map(
                                                                                (item: any, imgIndex: number) => (
                                                                                    <Grid
                                                                                        key={item.image_url}
                                                                                        size={imgIndex === 0 ? 6 : 3}
                                                                                    >
                                                                                        <SortableImage
                                                                                            item={item}
                                                                                            index={imgIndex}
                                                                                            large={imgIndex === 0}
                                                                                            onDelete={(i: number) => {
                                                                                                const updated = [
                                                                                                    ...variant.images,
                                                                                                ];

                                                                                                updated.splice(i, 1);

                                                                                                const normalized =
                                                                                                    updated.map(
                                                                                                        (img, idx) => ({
                                                                                                            ...img,
                                                                                                            sort_order: idx + 1,
                                                                                                            is_thumbnail:
                                                                                                                idx === 0,
                                                                                                        })
                                                                                                    );

                                                                                                setFieldValue(
                                                                                                    `variants.${index}.images`,
                                                                                                    normalized
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                )
                                                                            )}

                                                                        </Grid>
                                                                    </SortableContext>
                                                                </DndContext>
                                                            )}

                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                        </>
                                    )}
                                </FieldArray>

                                {index > 0 && (<Button
                                    className='btn-danger'
                                    variant='outlined'
                                    startIcon={<Delete />}
                                    sx={{ mt: 2, }}
                                    onClick={() =>
                                        remove(index)
                                    }
                                >
                                    Delete Variant
                                </Button>
                                )}
                            </Paper>
                        )
                    )}

                    <Button
                        className='btn-yellow'
                        onClick={() =>
                            push({
                                colorId: colorList[0].colorId,
                                sizeId: sizeList[0].sizeId,
                                price: "",
                                stock: "",
                                images: [],
                                discount_percentage: "",
                                discounted_price: "",
                            })
                        }
                    >
                        Add Variant
                    </Button>
                </>
            )}
        </FieldArray>
    )
}


// export const ReviewSubmit = ({ values }: any) => {
//     return (
//         <Paper className='bg-transparent border-bottom' sx={{ p: 2, mb: 2, boxShadow: 'none' }} >
//             <Typography variant="h6">
//                 Review Product
//             </Typography>

//             <pre>
//                 {JSON.stringify(
//                     values,
//                     null,
//                     2
//                 )}
//             </pre>
//         </Paper>
//     )
// }



interface Category {
    categoryName: string
    categoryId: number
}

interface Gender {
    genderName: string
    genderId: number
}
interface Color {
    colorName: string
    colorId: number
    colorCode: number
}
interface Size {
    sizeName: string
    sizeId: number
}

interface ProductMediaProps {
    values: any;
    setFieldValue: (field: string, value: any) => void;
}


const VariantInitializer = ({ activeStep, colorList, sizeList }: { activeStep: number, colorList: any, sizeList: any }) => {
    const { values, setFieldValue } = useFormikContext<any>();

    useEffect(() => {
        if (activeStep == 2 && values.variants.length === 0) {
            setTimeout(() => {
                setFieldValue("variants", [
                    {
                        colorId: colorList[0].colorId,
                        sizeId: sizeList[0].sizeId,
                        price: "",
                        stock: "",
                        images: [],
                        discount_percentage: "",
                        discounted_price: "",
                    },
                ], false); // ← false = don't validate after setting
            }, 0);
        }
    }, [activeStep]);
    return null;
};

function AddorUpdateProduct({ setOpenAddProduct }: any) {

    const [activeStep, setActiveStep] = useState(0);
    const [categoryList, setCategoryList] = useState<Category>()
    const [genderList, setGenderList] = useState<Gender>()
    const [colorList, setColorList] = useState<Color>()
    const [sizeList, setSizeList] = useState<Size>()
    const { venderDetails, teamId } = useSelector((state: RootState) => state.global)


    const getCategoryList = async () => {
        try {
            const res = await ApiGetAllCategory()
            if (res.status || res.success) {
                const result: any = categories?.map((item: any) => ({
                    categoryId: item.categoryId,
                    categoryName: item.categoryName,
                }));
                setCategoryList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }
    const getGenderList = async () => {
        try {
            const res = await ApiGetAllGender()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    genderId: item.genderId,
                    genderName: item.name,
                }));
                setGenderList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }
    const getColorList = async () => {
        try {
            const res = await ApiGetAllColors()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    colorId: item.colorId,
                    colorName: item.name,
                    colorCode: item?.hex_code
                }));

                setColorList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }
    const getSizeList = async () => {
        try {
            const res = await ApiGetAllSizes()
            if (res.status || res.success) {
                // console.log("FInal Data", res.data)
                const result = res.data.map((item: any) => ({
                    sizeId: item.sizeId,
                    sizeName: item.name,
                }));
                setSizeList(result)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message || "Something went wrong");
        }
    }


    useEffect(() => {
        activeStep == 0 && getCategoryList()
        activeStep == 0 && getGenderList()
        activeStep == 2 && getColorList()
        activeStep == 2 && getSizeList()
    }, [activeStep])

    const stepFields = [
        [
            "productName",
            "description",
            "categoryId",
            "genderId",
            "base_price",
            "discount_percentage"
        ],
        ["product_media"],
        ["variants"],
        [],
    ];
    // const { resetForm } = useFormikContext();

    // const handleNext = () => {
    //     setActiveStep((prev) => prev + 1);
    // };

    const steps = [
        "Product Details",
        "Product Media",
        "Variants",
        // "Variant Images",
        // "Review",
    ];


    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };


    const initialValues = {
        productName: "",
        description: "",
        categoryId: "",
        genderId: "",
        base_price: "",
        discount_percentage: 0,
        discounted_price: "",
        product_media: [],
        variants: [
            // {
            //     colorId: "",
            //     sizeId: "",
            //     price: "",
            //     stock: "",
            //     images: []
            // },
        ],
    };

    const validationSchema = Yup.object({
        productName: Yup.string().required("product name is required"),

        description: Yup.string().required("description is required"),

        categoryId: Yup.number()
            .required("category is required"),

        genderId: Yup.number()
            .required("gender is required"),

        base_price: Yup.number()
            .required("base price is required")
            .positive(),

        discount_percentage: Yup.number()
            .min(0, "Discount cannot be less than 0")
            .max(100, "Discount cannot be greater than 100")
            .required("Discount is required"),

        product_media: Yup.array()
            .of(
                Yup.object({
                    media_url: Yup.string().trim().required("Image required"),
                    // alt_text: Yup.string().required("Alt text required"),
                })
            )
            .min(1),

        variants: Yup.array()
            .of(
                Yup.object({
                    colorId: Yup.number().required(),
                    sizeId: Yup.number().required("Size is required"),

                    price: Yup.number()
                        .required("Price is required")
                        .positive(),

                    stock: Yup.number()
                        .required("Stock is required")
                        .min(0),

                    discount_percentage: Yup.number()
                        .min(0, "Discount cannot be less than 0")
                        .max(100, "Discount cannot be greater than 100")
                        .required("Discount is required"),

                    images: Yup.array()
                        .of(
                            Yup.object({
                                image_url: Yup.string().required("Image is required"),
                                alt_text: Yup.string().required(),
                            })
                        )
                        .min(1),
                })
            )
            .min(1),
    });

    const handleNext = async (formik: any) => {
        const errors = await formik.validateForm();
        const currentStepFields = stepFields[activeStep];

        const hasStepErrors = currentStepFields.some((field) => !!errors[field]);

        // if (!hasStepErrors) {
        setActiveStep((prev) => prev + 1);
        //     return;
        // }
        const touchedFields: any = {};
        currentStepFields.forEach((field) => {
            touchedFields[field] = true;
        });
        formik.setTouched(touchedFields, true);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
                try {
                    const data = {
                        ...values,
                        profileId: teamId,
                        currency: "AUD",
                        seller_type: "PLATFORM",
                    };

                    const res = await ApiCreateProduct(data);

                    if (res?.success || res?.status) {
                        resetForm();
                        setActiveStep(0);
                        setOpenAddProduct(false);
                        toast.success("Product created successfully");
                    }
                } catch (error: any) {
                    console.error("Error:", error);
                    toast.error(
                        error?.response?.data?.message ||
                        error?.message ||
                        "Something went wrong"
                    );
                } finally {
                    setSubmitting(false);
                }
            }}
            validateOnBlur
        // validateOnChange
        // validateOnMount
        >
            {(formik) => {
                return (
                    <Form className='create-product'>
                        {sizeList && colorList && (<VariantInitializer activeStep={activeStep} colorList={colorList} sizeList={sizeList} />)}
                        <Box className='d-flex align-items-center mb-4 justify-content-between'>
                            <Typography className='fs-24 text-white'>Create Product</Typography>
                            <IconButton onClick={() => {
                                formik.resetForm();
                                setActiveStep(0);
                                setOpenAddProduct(false);
                            }} className='p-0 m-0'>
                                <CancelOutlined className='text-white fs-28' />
                            </IconButton>
                        </Box>
                        <Stepper activeStep={activeStep}>
                            {steps.map((label) => (
                                <Step className='text-white' key={label}>
                                    <StepLabel className='text-white'>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>

                        <Box className='mt-4 form'>
                            {activeStep === 0 && <ProductInfo categoryList={categoryList} genderList={genderList} />}
                            {activeStep === 1 && <ProductMedia setFieldValue={formik.setFieldValue} values={formik.values} />}
                            {activeStep === 2 && <ProductVariants colorList={colorList} sizeList={sizeList} values={formik.values} setFieldValue={formik.setFieldValue} />}
                            {/* {activeStep === 3 && <VariantImage />} */}
                            {/* {activeStep === 3 && <ReviewSubmit />} */}
                        </Box>

                        <Box className='mt-4 d-flex justify-content-between'>
                            {activeStep !== 0 && (
                                <Button
                                    className='border-grey'
                                    type='button'
                                    sx={{ color: 'var(--text-grey)' }}
                                    variant='outlined'
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                >
                                    Back
                                </Button>
                            )}

                            {activeStep === steps.length - 1 ? (
                                <Button
                                    className='btn-yellow transform px-3 py-1'
                                    // type="submit"
                                    onClick={formik.submitForm}
                                >
                                    Submit
                                </Button>
                            ) : (
                                <Button type='button' className='btn-yellow ms-auto transform px-3 py-1'
                                    endIcon={<ArrowRightAlt />}
                                    onClick={() => handleNext(formik)}
                                >
                                    Next
                                </Button>
                            )}
                        </Box>
                    </Form>
                )
            }}

        </Formik>
    )
}

export default AddorUpdateProduct
